var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(this.$route.path!=='/'&&this.$route.path!=='/login_tpa')?_c('index-component'):(this.$route.path=='/'||this.$route.path=='/login_tpa')?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }